export default {
  header: 'Non è stato possibile caricare il tuo ordine',
  text: 'Si è verificato un errore durante la preparazione del tuo ordine. Il tuo carrello è al sicuro: riprova.',
  retry: 'Riprova',
  address_header: 'Ci serve il tuo indirizzo di consegna',
  address_text: 'Non possiamo calcolare il totale finché non sappiamo dove consegnare. Il tuo carrello è al sicuro.',
  address_action: 'Aggiungi indirizzo di consegna',
  back_checkout: 'Torna al tuo ordine',
  back_basket: 'Torna al tuo carrello',
};
